import {Component, Inject, OnInit} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MAT_DIALOG_DATA, MatDialogRef, MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-add-devex-configuration-new',
  templateUrl: './add-devex-configuration-new.component.html',
  styleUrls: ['./add-devex-configuration-new.component.scss']
})
export class AddDevexConfigurationNewComponent implements OnInit {


  selectable = true;
  removable = true;
  addOnBlur = true;
  selectedOption: any;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  cloud_options = [
    { value: 'aws', label: 'Amazon Web Service', logo: 'assets/img/cloud/aws-logo.png', width: '20px', height: '13px' },
    { value: 'azure', label: 'Microsoft Azure', logo: 'assets/img/cloud/azure-logo.png', width: '25px', height: '15px' },
    { value: 'gcp', label: 'Google Cloud Platform', logo: 'assets/img/cloud/gcp-logo.webp', width: '20px', height: '15px' },
  ];
  primaryRegionOptions: { [key: string]: string[] } = {
    aws: ['US East (Ohio)', 'US East (N. Virginia)', 'US West (N. California)', 'US West (Oregon)','Africa (Cape Town)','Asia Pacific (Hong Kong)','Asia Pacific (Hyderabad)','Asia Pacific (Jakarta)', 'Asia Pacific (Melbourne)','Asia Pacific (Mumbai)',
    'Asia Pacific (Osaka)','Asia Pacific (Seoul)','Asia Pacific (Singapore)','Asia Pacific (Sydney)','Asia Pacific (Tokyo)','Canada (Central)','Canada West (Calgary)','Europe (Frankfurt)','Europe (Ireland)','Europe (London)','Europe (Milan)','Europe (Paris)',
    'Europe (Spain)','Europe (Stockholm)', 'Europe (Zurich)', 'Israel (Tel Aviv)', 
    'Middle East (Bahrain)','Middle East (UAE)','South America (São Paulo)',
    'AWS GovCloud (US-East)','AWS GovCloud (US-West)'],
    azure: ['East Asia', 'Southeast Asia','Australia Central','Australia East','Australia Southeast','China East','China East 2','China North','China North 2','China North 3','Central India','India South Central','South India','Indonesia Central','Japan East','Japan West',
    'Korea Central','Malaysia West','New Zealand North','Saudi Arabia Central','Taiwan North'],
    gcp: ['US Central1 (Iowa)', 'US East4 (N. Virginia)', 'Europe West2 (London)','Europe West4 (Netherlands)'],
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AddDevexConfigurationNewComponent>, private snackBar: MatSnackBar) {
    dialogRef.disableClose = true;

  }

  ngOnInit() {

  }

  isValidUrl(url: string): boolean {
    const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*$/;
    return urlPattern.test(url);
  }

  onCloudSelectionChange(event: any): void {
    this.selectedOption = this.getCloudInfo(event);
    this.data['configuration']['regions'] = []
  }

  getCloudInfo(key: string) {
    const selectedOption = this.cloud_options.find(option => option.value === key);
    return {
      logo: selectedOption.logo,
      label: selectedOption.label,
      width: selectedOption.width,
      height: selectedOption.height
    };
  }
  add(event, data): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      data.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(val, data): void {
    const index = data.indexOf(val);

    if (index >= 0) {
      data.splice(index, 1);
    }
  }

  close() {
    this.dialogRef.close();
  }

  addConfiguration() {
    if (this.data['configuration']['name'] !== '' && this.data['configuration']['url'] !== '' && this.data['configuration']['cloud'] !== '' &&
        this.data['configuration']['primary_region'] !== '' && this.data['configuration']['regions'].length > 0) {
      this.dialogRef.close(this.data['configuration']);
    } else {
      this.snackBar.open('Please provide all the required values', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

}
